// 📁 components/BannerManager.tsx
import { UploadOutlined, DeleteOutlined } from '@ant-design/icons';
import { Upload, Button, Input, Form, message, List, Card, Space, Popconfirm } from 'antd';
import axios from 'axios';
import { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from 'react-query';

const BannerManager = () => {
  const queryClient = useQueryClient();
  const [form] = Form.useForm();
  const [imageFile, setImageFile] = useState<any>(null);

  const { data: banners = [], isLoading } = useQuery('newsletterBanners', async () => {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/newsletter-banners`);
    return res.data;
  });

  const createBanner = useMutation(
    async (formData: FormData) => {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/newsletter-banners`, formData);
      return res.data;
    },
    {
      onSuccess: () => {
        message.success('Banner uspješno dodan!');
        form.resetFields();
        setImageFile(null);
        queryClient.invalidateQueries('newsletterBanners');
      },
      onError: () => {
        message.error('Greška prilikom dodavanja bannera.');
      },
    },
  );

  const deleteBanner = useMutation(
    async (id: string) => {
      await axios.delete(`${process.env.REACT_APP_API_URL}/api/newsletter-banners/${id}`);
    },
    {
      onSuccess: () => {
        message.success('Banner izbrisan.');
        queryClient.invalidateQueries('newsletterBanners');
      },
      onError: () => {
        message.error('Greška prilikom brisanja bannera.');
      },
    },
  );

  const onFinish = (values: any) => {
    if (!imageFile) {
      message.warning('Molimo dodajte sliku.');
      return;
    }

    const formData = new FormData();
    formData.append('image', imageFile);
    formData.append('link', values.link || '');

    createBanner.mutate(formData);
  };

  return (
    <Card title="📸 Upravljanje Bannerima za Newsletter" style={{ marginTop: 20 }}>
      <Form layout="vertical" form={form} onFinish={onFinish}>
        <Form.Item label="Link (opcionalno)" name="link">
          <Input placeholder="https://..." />
        </Form.Item>

        <Form.Item label="Odaberi sliku">
          <Upload
            beforeUpload={(file) => {
              setImageFile(file);
              return false;
            }}
            showUploadList={true}
            fileList={
              imageFile
                ? [
                    {
                      uid: '-1',
                      name: imageFile.name,
                      status: 'done',
                      url: URL.createObjectURL(imageFile),
                    },
                  ]
                : []
            }
          >
            <Button icon={<UploadOutlined />}>Dodaj sliku</Button>
          </Upload>
        </Form.Item>

        <Button type="primary" htmlType="submit" loading={createBanner.isLoading}>
          Spremi Banner
        </Button>
      </Form>

      <List
        header={<strong>Trenutni banneri</strong>}
        loading={isLoading}
        dataSource={banners}
        renderItem={(item: any) => (
          <List.Item>
            <Card style={{ width: '100%' }}>
              <Space direction="horizontal" style={{ justifyContent: 'space-between', width: '100%' }}>
                <img
                  src={item.imageUrl}
                  alt="banner"
                  style={{ width: '100%', maxWidth: '600px', borderRadius: '6px', objectFit: 'cover' }}
                />

                <div>
                  {item.link && (
                    <div>
                      <strong>Link:</strong>{' '}
                      <a href={item.link} target="_blank" rel="noopener noreferrer">
                        {item.link}
                      </a>
                    </div>
                  )}
                </div>

                <Popconfirm
                  title="Sigurno želite izbrisati ovaj banner?"
                  onConfirm={() => deleteBanner.mutate(item.id)}
                  okText="Da"
                  cancelText="Ne"
                >
                  <Button type="primary" danger icon={<DeleteOutlined />} />
                </Popconfirm>
              </Space>
            </Card>
          </List.Item>
        )}
      />
    </Card>
  );
};

export default BannerManager;
